import { Button, Form, Icon, Section } from 'react-bulma-components';
import React, { useState } from 'react';

import Exercise from '../containers/exercise';
import ExerciseEdit from '../containers/exercise-edit';
import Finder from '../containers/finder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageTitle from '../components/pagetitle';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

const { Control } = Form;
const Library = () => {
  const [currentItemId, setCurrentItemId ] = useState(null);
  const [editExercise, setEditExercise] = useState(false);

  const onItemSelect = (data) => {
    console.log(data);
    if (data !== null && data.kind==="exc") {
      setCurrentItemId(data.id);
    }
    else{
      setCurrentItemId(null);
    }
  }

  const handleCloseEdit = () => {
    setEditExercise(false);
  }

  return (
    <>
      <PageTitle name="Library" description="Structured resources" />
      <Section>
        <Finder  rootFolder="root" onItemSelect={onItemSelect}/>
      </Section>
      {currentItemId!==null &&
        <Section>
          {editExercise===true ?
            <ExerciseEdit id={currentItemId} closeEdit={handleCloseEdit}/>
            :
            <>
            <Control>
              <Button size="small" type="button" onClick={() => setEditExercise(!editExercise)}>
                <Icon color="info"><FontAwesomeIcon icon={faEdit} /></Icon>
              </Button>
              </Control>
              <Exercise ref={null} id={currentItemId} />
            </>
           }
        </Section>
      }
    </>
  )
}


export default Library;